module.exports = __webpack_public_path__ + "static/media/RR-waving-rc2.a2423c5e.jpg";